export default {
  "content": "<path d=\"M5.156 9.281h22.688M5.156 16.5h22.688M5.156 23.719h22.688\" stroke=\"var(--Primary-Text-Color)\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "33",
    "height": "33",
    "viewBox": "0 0 33 33",
    "fill": "none"
  }
};